import {useEffect} from 'react';
import {useAppSelector} from '../store';

function Favicon() {
  const faviconState = useAppSelector((state) => state.favicon);
  useEffect(() => {
    let iconLink = document.getElementById('favicon');
    let appleTouchIconLink = document.getElementById('apple-touch-icon');
    iconLink?.setAttribute('href', faviconState.faviconValue);
    appleTouchIconLink?.setAttribute(
      'href',
      faviconState.appleTouchFaviconValue,
    );
  }, [faviconState]); // Re-run effect if href changes

  return null; // This component doesn't render any visible UI
}

export default Favicon;
